<template>
    <div class="banner_container">
        <template v-if="bannerList.length > 1">
            <swiper :options="swiperOptions" class="swiper">
                <swiper-slide
                    class="swiper_item"
                    v-for="item in bannerList"
                    :key="item.id"
                >
                    <img :src="item.address" />
                </swiper-slide>
            </swiper>
            <div class="swiper_prev iconfont icon-zuo"></div>
            <div class="swiper_next iconfont icon-you"></div>
        </template>
        <img v-else class="img" :src="bannerList[0].address" />
    </div>
</template>

<script>
import 'swiper/swiper-bundle.min.css';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
SwiperCore.use([Navigation, Autoplay]);

export default {
    props: {
        bannerList: {
            type: Array,
            default: () => {
                return [];
            },
            required: true,
        },
    },
    data() {
        return {
            swiperOptions: {
                slidesPerView: 3,
                grabCursor: true,
                spaceBetween: 0,
                centeredSlides: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                loop: true,
                navigation: {
                    nextEl: '.swiper_next',
                    prevEl: '.swiper_prev',
                },
            },
        };
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.banner_container {
    width: 100%;
    position: relative;
    overflow: hidden;
    // 只有一张图不轮播
    .img {
        display: block;
        width: 1110px;
        height: 430px;
        object-fit: cover;
        margin: 0 auto;
    }
    .swiper {
        z-index: 0;
        margin-left: calc(((100% - 1110px) / 2) - 1110px);
        .swiper-slide-active,
        .swiper-slide-prev,
        .swiper-slide-next {
            width: 1110px !important;
        }
        .swiper_item img {
            width: 1110px;
            height: 430px;
            object-fit: cover;
            display: block;
        }
    }
    .swiper_prev,
    .swiper_next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        font-size: 48px;
        z-index: 2;
        color: #c4c3c6;
        cursor: pointer;
        &:hover {
            color: #fff;
        }
    }
    .swiper_prev {
        left: calc(((100% - 1110px) / 2) - 72px);
    }
    .swiper_next {
        right: calc(((100% - 1110px) / 2) - 72px);
    }
    &::before,
    &::after {
        content: '';
        width: calc((100% - 1110px) / 2);
        height: 100%;
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1;
    }
    &::before {
        left: 0;
        top: 0;
    }
    &::after {
        right: 0;
        top: 0;
    }
}
</style>
